import React, { useState, useEffect, useContext } from "react";
import { Typography, IconButton, Tooltip, Stack, Divider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getActiveCreditsAsync } from "../../../api/Dashboard";

const ActiveCredits = () => {
  const [activeCredits, setActiveCredits] = useState(0);
  const { setIsLoading, setIsLogged, setIsUnautorized } =
    useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getActiveCreditsAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setActiveCredits(result.data.result);
    })();
  }, []);

  return (
    <div>
      <Stack
        direction={"row"}
        style={{ padding: 10 }}
        justifyContent="space-between"
        alignItems={"center"}
      >
        <Tooltip title="Ver Créditos">
          <IconButton
            sx={{ border: 1, borderColor: "rgba(54, 162, 235, 1)" }}
            style={{
              width: 100,
              height: 100,
              backgroundColor: "rgba(54, 162, 235, 0.2)",
            }}
            onClick={() => navigate(`${ruta}/credits`)}
          >
            <FontAwesomeIcon
              icon={faHandHoldingDollar}
              style={{
                fontSize: 60,
                color: "rgba(54, 162, 235, 1)",
                opacity: 0.3,
                padding: 10,
              }}
            />
          </IconButton>
        </Tooltip>
        <Typography
          align="right"
          style={{
            color: "rgba(54, 162, 235, 1)",
            fontWeight: 800,
            fontSize: 30,
          }}
          paragraph
        >
          {activeCredits}
        </Typography>
      </Stack>
      <Divider />
      <Typography
        variant="subtitle1"
        align="center"
        style={{ color: "rgba(54, 162, 235, 1)", fontSize: 20 }}
      >
        Créditos Activos
      </Typography>
    </div>
  );
};

export default ActiveCredits;
